import {
  successAction,
  types,
  errorAction,
  requestAction,
} from "@authzsvc/api-lib";

import * as at from "../actions/types";

const initialState = {
  loading: false,
  data: [],
  resourceType: {}, // multiple types handling
};

const resourceType = (state = initialState, action) => {
  switch (action.type) {
    case at.CLEAR_RESOURCES:
      return { ...state, data: [], resourceType: {} };
    case errorAction(types.GET_ALL_MY_RESOURCES_OF_TYPE):
      return { ...state, loading: false };
    case successAction(types.GET_ALL_MY_RESOURCES_OF_TYPE):
    case successAction(types.GET_CURRENT_IDENTITY_ACCOUNTS): {
      // If we want to properly handle /resources/Account we need to handle
      // GET_CURRENT_IDENTITY_ACCOUNTS action as well.
      // Ugly workaround for /Identity/my endpoint which always returns a single object
      // rather than an array of objects.
      const data = Array.isArray(action.payload.data)
        ? action.payload.data
        : [action.payload.data];
      // Resources by ResourceTypes
      if (action.payload.resourceType)
        state.resourceType[action.payload.resourceType] = data;
      return { ...state, data: data, loading: false };
    }
    case requestAction(types.GET_ALL_MY_RESOURCES_OF_TYPE):
    case requestAction(types.GET_CURRENT_IDENTITY_ACCOUNTS):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default resourceType;
